<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="scarInfo">
        <div class="article">
          <label>수술명</label>
          <p>{{surgeryName}}</p>
        </div>
        <div class="article">
          <label>수술일정</label>
          <p>{{surgeryDate | moment('YYYY-MM-DD')}}</p>
        </div>
      </div>
      <div class="scarListWrap">
        <div class="monthlyItem" v-for="n in Object.keys(this.timeTableFlag).length" :key="n">
          <p class="board">{{n}}개월 후</p>
          <v-gallery class="image-box" :control-title = false :images = scarList[n]>
            <div class="imageSet" v-if = "(isDataFetched && scarList[n])">
              <div class="viewWrap"  v-for="(itemSet , i) in scarList[n]" :key="i" :style="{ height: heightAuto + 'px'}">
                <a
                  v-if="itemSet.url && itemSet.thumbnail"
                  href="javascript:void(0);"
                  :data-image="itemSet.url"
                  :title="itemSet.title"
                  :key="itemSet.id">
                  <div class="bgbox">
                    <img :src="itemSet.thumbnail">
                  </div>
                  <!-- <div class="img-title" v-html="itemSet.title"></div> -->
                </a>
                <div class="deleteAction" v-on:click.stop.prevent="deletePre(n, itemSet.id)">
                  <img src="@/assets/images/ck_on.svg">
                </div>
              </div>
              <div class="viewWrap" @click="uploadImage(n)" :style="{ height: heightAuto + 'px'}">
                <div class="preView add">
                  <p class="notice">이미지 등록</p>
                </div>
              </div>
            </div>
          </v-gallery>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet" @causeAction="deletePicture()"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '흉터관리 리스트',
        prevUrl: '/'
      },
      transNum: '',
      transId: '',
      surgeryName: '',
      surgeryDate: '',
      scarList: [],
      scarDetailList: {},
      isDataFetched: false,
      /* scarList: {
          month1: [
            {
              id: 1,
              thumbnail: '/media/doctor/이익준_DxFExr4.jpg',
              image: '/media/doctor/이익준_DxFExr4.jpg'
            },
            {
              id: 2,
              thumbnail: '/media/doctor/김준완.jpg',
              image: '/media/doctor/김준완.jpg'
            },
            {
              id: 3,
              thumbnail: '/media/doctor/채송화.jpg',
              image: '/media/doctor/채송화.jpg'
            },
            {
              id: 4,
              thumbnail: '/media/doctor/양석형.jpg',
              image: '/media/doctor/양석형.jpg'
            },
            {
              id: 5,
              thumbnail: '/media/doctor/크기변환설현.jpg',
              image: '/media/doctor/크기변환설현.jpg'
            }
          ],
          month2: [
            {
              id: 6,
              thumbnail: '/media/doctor/안정원.jpg',
              image: '/media/doctor/안정원.jpg'
            }
          ]
        }, */
      IsInsert: '',
      keySet: '',
      valueSet: '',
      heightAuto: '',
      sampleImg: '',
      timeTableFlag: {
        1: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        2: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        3: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        4: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        5: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        6: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        7: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        8: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        9: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        10: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        11: [
          {
            month: false,
            IsAddMonth: false
          }
        ],
        12: [
          {
            month: false,
            IsAddMonth: false
          }
        ]
      },
      teraList: {
        1: [
          {
            id: 1
          },
          {
            id: 2
          },
          {
            id: 3
          },
          {
            id: 4
          }
        ],
        2: [
          {
            id: 5
          },
          {
            id: 6
          }
        ],
        3: [
          {
            id: 7
          }
        ],
        6: [
          {
            id: 11
          }
        ],
        8: [
          {
            id: 13
          },
          {
            id: 14
          }
        ],
        9: [
          {
            id: 15
          }
        ],
        10: [
          {
            id: 16
          }
        ],
        11: [
          {
            id: 17
          }
        ]
      }
    }
  },
  async created () {
    if (this.GET_UPLOAD_MESSAGE === true) {
      this.SET_POPUP(true)
      this.popupSet.content = '흉터이미지가 등록되었습니다.'
      this.$store.commit('SET_UPLOAD_MESSAGE', false)
    }
    if (this.GET_SCAR_INFO.surgeryName !== '') {
      this.surgeryName = this.GET_SCAR_INFO.surgeryName
      this.surgeryDate = this.GET_SCAR_INFO.surgeryDate
      console.log('surgeryName', this.surgeryName)
      console.log('surgeryDate', this.surgeryDate)
    }
    await this.fetchImgList()
    this.visualTrans()
    // this.practice()
    // this.makeItem()
  },
  computed: {
    ...mapGetters([
      'GET_SCAR_INFOCODE',
      'GET_UPLOAD_LIST',
      'GET_UPLOAD_MESSAGE',
      'GET_FETCHED_SCARIMG',
      'GET_SCAR_INFO'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_UPLOAD_PRE_DATA'
    ]),
    ...mapActions([
      'FETCH_SCAR_UPLOAD',
      'FETCH_SCAR_IMAGE',
      'DELETE_SCAR_IMAGE'
    ]),
    arrayDelete () {
      const sample = this.teraList[1]
      delete sample[0]
      console.log('지운 후', sample)
    },
    async viewImg (order, id) {
      console.log('순번', order)
      let orderly
      for (let i = 0; i < this.scarList[order].length; i++) {
        if (this.scarList[order][i].id === id) {
          orderly = i
        }
      }
      console.log('가져온 ID값', id)
      console.log('DIV의 순서', orderly)
      const scarImgId = id
      try {
        const userData = {
          id: scarImgId,
          thumbnail: false
        }
        await this.FETCH_SCAR_IMAGE(userData)
          .then(() => {
            const result = URL.createObjectURL(this.GET_FETCHED_SCARIMG)
            console.log('결과', result)
            document.getElementById('tts1').src = result
          })
      } catch (error) {
        const urlMaterial = error.config.url
        const apiErrorURL = urlMaterial.substr(0, 30)
        console.log('api 에러 URL', apiErrorURL.trim())
        console.log('흉터관리 이미지 가져오기 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    practice () {
      console.log('작업물', this.teraList)
      console.log('내용물', this.teraList[1])
      console.log('사용물', this.teraList[1].length)
      const excu = Object.entries(this.teraList)
      const keyArray = []
      const valueArray = []
      for (const [key, value] of excu) {
        keyArray.push(key)
        valueArray.push(value)
      }
      console.log('keyArray', keyArray)
      console.log('keyArrayLength', keyArray.length)
      const promiseList = []
      console.log(promiseList)
      for (let i = 0; i < keyArray.length; i++) {
        for (let j = 0; j < this.teraList[keyArray[i]].length; j++) {
          const imageId = this.teraList[keyArray[i]][j].id
          promiseList.push(this.drawPicture(imageId))
        }
      }
      console.log(promiseList)
      Promise.all(promiseList).then(() => {
        this.isDataFetched = true
      })
    },
    async drawPicture (id, firstNum, secondNum) {
      try {
        const requestThumbnailData = {
          id: id,
          thumbnail: true
        }
        await this.FETCH_SCAR_IMAGE(requestThumbnailData)
          .then(() => {
            const result = URL.createObjectURL(this.GET_FETCHED_SCARIMG)
            // 이미지의 주소에 모두 값을 주입해야함
            this.scarList[this.keySet[firstNum]][secondNum].thumbnail = result
            // document.getElementById('' + id + '').src = result
          })
        const requestOriginData = {
          id,
          thumbnail: false
        }
        await this.FETCH_SCAR_IMAGE(requestOriginData)
          .then(() => {
            const result = URL.createObjectURL(this.GET_FETCHED_SCARIMG)
            // 이미지의 주소에 모두 값을 주입해야함
            this.scarList[this.keySet[firstNum]][secondNum].src = result
            this.scarList[this.keySet[firstNum]][secondNum].url = result
            this.scarList[this.keySet[firstNum]][secondNum].title = ''
            // document.getElementById('' + id + '').src = result
          })
      } catch (error) {
        const urlMaterial = error.config.url
        const apiErrorURL = urlMaterial.substr(0, 30)
        console.log('api 에러 URL', apiErrorURL.trim())
        console.log('흉터관리 이미지 불러오기 api에서 에러발생.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    deletePre (num, id) {
      this.transNum = num
      this.transId = id
      this.SET_POPUP(true)
      this.popupSet.content = '이미지를 삭제하시겠습니까?'
      this.popupSet.count = 'causeActionNormal'
    },
    async deletePicture () {
      let orderly
      const order = this.transNum
      const id = this.transId
      for (let i = 0; i < this.scarList[order].length; i++) {
        if (this.scarList[order][i].id === id) {
          orderly = i
        }
      }
      console.log('가져온 로우의 순번', order)
      console.log('선택된 지울순번', orderly)
      console.log('가져온 이미지의 pk', id)
      // HTML 초기화
      const itemSet = document.querySelector('.monthlyItem').parentNode.childNodes[Number(order) - 1]
      const target = itemSet.querySelectorAll('.viewWrap')[orderly]
      const targetParent = target.parentNode

      console.log('지울타겟', target)
      targetParent.removeChild(target)
      const deleteSetLocation = this.scarList[order]
      try {
        const requestData = {
          scarInfoCode: Number(this.GET_SCAR_INFOCODE),
          scarCode: id
        }
        await this.DELETE_SCAR_IMAGE(requestData)
          .then(() => {
            delete deleteSetLocation[orderly]
            this.scarList = []
            this.transNum = ''
            this.transId = ''
            this.fetchImgList()
            this.SET_POPUP(false)
            this.SET_POPUP(true)
            this.popupSet.content = '이미지가 삭제되었습니다.'
          })
      } catch (error) {
        const urlMaterial = error.config.url
        const apiErrorURL = urlMaterial.substr(0, 30)
        console.log('api 에러 URL', apiErrorURL.trim())
        console.log('흉터관리 이미지 삭제 api에서 에러발생.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    newMark () {
      const result = URL.createObjectURL(this.GET_FETCHED_SCARIMG)
      console.log('결과', result)
      document.getElementById('tts1').src = result
    },
    transBinary () {
      const bytes = new Uint8Array(this.GET_FETCHED_SCARIMG.blob)
      const blob = new Blob([bytes], { type: 'application/octet-binary' })
      const result = URL.createObjectURL(blob)
      this.sampleImg = result
    },
    async prepareImg () {
      console.log('가져온 이미지 코드', this.GET_FETCHED_SCARIMG)
      this.newMark()
      // this.findAttr()
    },
    uploadImage (month) {
      const requestData = {
        scarInfoCode: Number(this.GET_SCAR_INFOCODE),
        afterMonth: month
      }
      this.$store.commit('SET_UPLOAD_PRE_DATA', requestData)
      this.$router.push('./scarUpload')
    },
    visualTrans () {
      const transHeight = ((window.innerWidth - 40) / 3)
      this.heightAuto = transHeight
    },
    async fetchImgList () {
      try {
        const requestData = {
          scarInfoCode: Number(this.GET_SCAR_INFOCODE)
        }
        await this.FETCH_SCAR_UPLOAD(requestData)
          .then(() => this.makeUsual())
      } catch (error) {
        const urlMaterial = error.config.url
        const apiErrorURL = urlMaterial.substr(0, 30)
        console.log('api 에러 URL', apiErrorURL.trim())
        console.log('흉터관리 사진 업로드 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    moduleFetch () {
      // 지우기 신공
    },
    makeUsual () {
      console.log('업로드 리스트의 값', this.GET_UPLOAD_LIST)
      this.scarList = this.GET_UPLOAD_LIST
      const excu = Object.entries(this.scarList)
      const keyArray = []
      const valueArray = []
      for (const [key, value] of excu) {
        keyArray.push(key)
        valueArray.push(value)
      }
      this.keySet = keyArray
      this.valueSet = valueArray
      console.log('객체를 배열로 변환한 값', keyArray)
      console.log('키값은?', Object.keys(this.scarList))
      const promiseList = []
      for (let i = 0; i < keyArray.length; i++) {
        // 몇월의 값에 이미지가 있는지 확인하기
        for (let j = 0; j < Object.keys(this.timeTableFlag).length; j++) {
          if (keyArray[i].indexOf(j) === 0) {
            this.timeTableFlag[j][0].month = true
          }
        }
        for (let j = 0; j < this.scarList[keyArray[i]].length; j++) {
          const imageId = this.scarList[keyArray[i]][j].id
          promiseList.push(this.drawPicture(imageId, i, j))
        }
      }
      Promise.all(promiseList).then(() => {
        this.isDataFetched = true
      })
      /* if (keyArray.indexOf('month1') !== -1) {
          console.log('참트루')
          this.timeTableFlag.month1 = true
          if (this.scarList.month1.length < 3) {
            this.monthAble.IsAddMonth1 = true
          }
          console.log('1개월 후는 이미지가 있습니다.')
        } */
    },
    makeItem () {
      const InInsertArray = []
      for (let i = 0; i < Object.keys(this.scarList).length; i++) {
        InInsertArray.push(this.scarList)
      }
      this.IsInsert = InInsertArray
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
  .image-box{
    a {
      width : 100%;
      height: 100%;
      clear: both;
      display: inline-block;
      margin: 0 10px 10px 0;
      position: relative;
      text-align: center;
      .bgbox {
        width : 100%;
        height: 100%;
        vertical-align:middle;
        border-radius: 2px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      &:hover {
        .img-title { color: #232323; }
      }
    }
    .v-gallery {
      width: 100%;

      & > div {
        display: block !important;
        width : 100% !important;
        height: 100% !important;
      }
    }
  }
</style>
